// import { Twitter, Linkedin } from "lucide-react";
import { useState } from "react";
import SuccessDialog from "./success-dialog";
import { ref, set } from "firebase/database";
import database from "../firebase";

function Copyright() {
  return (
    <p className="text-sm text-canvas/70">
      Copyright © FIGHN AFRICA {new Date().getFullYear()} | All rights reserved.
    </p>
  );
}

function FooterPage({ preFooter }) {
  const [email, setEmail] = useState("");
  const [dialogOpen, setDialogOpen] = useState(false);

  const handleChange = (e) => setEmail(e.target.value);

  const generateRandomId = () => {
    const characters =
      "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
    let result = "";
    for (let i = 0; i < 10; i++) {
      result += characters.charAt(Math.floor(Math.random() * characters.length));
    }
    return result;
  };

  const subscribe = async (e) => {
    e.preventDefault();
    if (email !== "") {
      const messageRef = ref(database, `Emails/${generateRandomId()}`);
      try {
        await set(messageRef, { email });
        setDialogOpen(true);
      } catch (error) {
        console.error("Error sending message:", error);
      }
    }
  };

  const handleCloseDialog = () => setDialogOpen(false);

  return (
    <div className="flex flex-col items-center gap-8 mt-8">
      {preFooter && (
        <div className="max-w-6xl w-full px-6 sm:px-8 flex flex-col sm:flex-row justify-between gap-8">
          <div className="flex flex-col gap-4 min-w-full sm:min-w-[60%]">
            <img src="media/lg1.png" alt="Fighn logo" className="w-20 h-auto -ml-1" />
            <div>
              <p className="text-sm font-semibold text-ink mb-1">Newsletter</p>
              <p className="text-sm text-ink/60 mb-3">
                Subscribe to our newsletter for future updates.
              </p>
              <form onSubmit={subscribe} className="flex gap-2 max-w-sm">
                <input
                  id="email"
                  name="email"
                  type="email"
                  autoComplete="off"
                  placeholder="Your email address"
                  aria-label="Enter your email address"
                  onChange={handleChange}
                  className="flex-1 rounded-full border border-forest/20 px-4 py-2 text-sm focus:outline-none focus:border-forest"
                />
                <button
                  type="submit"
                  className="bg-forest text-canvas text-sm font-medium px-5 py-2 rounded-full hover:bg-forest-dark transition-colors whitespace-nowrap"
                >
                  Subscribe
                </button>
              </form>
            </div>
          </div>
        </div>
      )}

      <div className="w-full flex justify-between items-center px-6 sm:px-8 py-6 border-t border-canvas/10 bg-ink text-canvas">
        <Copyright />
        <div className="flex gap-3">
          {/* <a
            href="https://x.com/MaterialUI"
            aria-label="Twitter"
            className="w-9 h-9 rounded-full border border-canvas/20 flex items-center justify-center hover:bg-canvas/10 transition-colors"
          >
            <Twitter className="w-4 h-4" />
          </a> */}
          {/* <a
            href="https://www.linkedin.com/company/mui/"
            aria-label="LinkedIn"
            className="w-9 h-9 rounded-full border border-canvas/20 flex items-center justify-center hover:bg-canvas/10 transition-colors"
          >
            <Linkedin className="w-4 h-4" />
          </a> */}
        </div>
      </div>

      <SuccessDialog
        open={dialogOpen}
        onClose={handleCloseDialog}
        message="Thanks for subscribing to our Newsletter!"
      />
    </div>
  );
}

export default FooterPage;